import { SIDEBARS_STATE } from "../../constants"
import { DEFAULT_LEFT_SIDEBAR_WIDTH, DEFAULT_RIGHT_SIDEBAR_WIDTH } from "./constant"
import { safeJsonParse } from "../common/safeJsonParse"

interface SidebarsState {
    dialogsListWidth: number
    mainSurveyWidth: number
    mainSurveyIsOpened: boolean
}

const defaultSidebarsState: SidebarsState = {
    dialogsListWidth: DEFAULT_LEFT_SIDEBAR_WIDTH,
    mainSurveyWidth: DEFAULT_RIGHT_SIDEBAR_WIDTH,
    mainSurveyIsOpened: true
}

export const getSidebarsState = (): SidebarsState => {
    if (typeof window === "undefined") {
        return defaultSidebarsState
    }

    const raw = localStorage.getItem(SIDEBARS_STATE) ?? ""
    const safeSidebarState = safeJsonParse<Partial<SidebarsState>>(raw, {})

    return { ...defaultSidebarsState, ...safeSidebarState }
}

export const updateSidebarsState = (patch: Partial<SidebarsState>) => {
    const current = getSidebarsState()

    localStorage.setItem(SIDEBARS_STATE, JSON.stringify({ ...current, ...patch }))
}
